import request from '@/utils/request'
/**
 * 新测评系统接口
 * 
 */
//我的
export function my(data) {
    return request({
        url: '/admin/ceping/my',
        method: 'POST',
        data: data || {}
    })
}

//提交个人信息接口
export function save_personal(data) {
    return request({
        url: '/admin/ceping/save_personal',
        method: 'POST',
        data: data || {}
    })
}

//提交个人资料接口
export function save_userinfo(data) {
    return request({
        url: '/admin/ceping/save_userinfo',
        method: 'POST',
        data: data || {}
    })
}

//商品详情
export function goods_detail(data) {
    return request({
        url: '/admin/ceping/detail',
        method: 'POST',
        data: data || {}
    })
}
//自动兑换测评
export function auto_redeem_submit(data) {
    return request({
        url: '/admin/ceping/auto_redeem_submit',
        method: 'POST',
        data: data || {}
    })
}
//更新测评进度
export function progress(data) {
    return request({
        url: '/admin/ceping/progress',
        method: 'POST',
        data: data || {}
    })
}
//兑换码支付测评
export function exchange(data) {
    return request({
        url: '/admin/ceping/exchange',
        method: 'POST',
        data: data || {}
    })
}

//获取赠送测评表单接口
export function ceping_present(data) {
    return request({
        url: '/api/form/ceping_present',
        method: 'POST',
        data: data || {}
    })
}

//提交赠送测评表单接口
export function ceping_submit(data) {
    return request({
        url: '/api/form/submit',
        method: 'POST',
        data: data || {}
    })
}

//赠送测评-测评码
export function get_present_code(data) {
    return request({
        url: '/api/ceping/get_present_code',
        method: 'POST',
        data: data || {}
    })
}

//赠送测评-获取测评商品
export function detail(data) {
    return request({
        url: '/admin/ceping/detail',
        method: 'POST',
        data: data || {}
    })
}

//企业端---测评白名单
export function check(data) {
    return request({
        url: '/admin/ceping/check',
        method: 'POST',
        data: data || {}
    })
}

//测评商品---检查订单是否支付
export function check_order_status(data) {
    return request({
        url: '/admin/ceping/check_order_status',
        method: 'POST',
        data: data || {}
    })
}


//商品详情
export function ext_goods_detail(data) {
    return request({
        url: '/admin/ext_ceping/detail',
        method: 'POST',
        data: data || {}
    })
}

//兑换码支付测评
export function ext_exchange(data) {
    return request({
        url: '/admin/ext_ceping/exchange',
        method: 'POST',
        data: data || {}
    })
}

//测评商品---检查订单是否支付
export function ext_check_order_status(data) {
    return request({
        url: '/admin/ext_ceping/check_order_status',
        method: 'POST',
        data: data || {}
    })
}